<template>
  <site-header>
    <h1 class="mb-8 text-[2.5rem] font-bold uppercase text-white">
      Notre concept<br />
    </h1>
    <search-routes class="left-5 right-5 max-md:absolute"></search-routes>
  </site-header>
  <section-wrapper>
    <section-layer
      class="bg-left-top bg-no-repeat max-[1665px]:bg-[length:300px_300px] max-xl:bg-[length:150px_150px]"
      background="/images/ROND VIOLET.png"
    >
    </section-layer>

    <section-layer
      class="bg-top bg-no-repeat [@media(max-width:84.375rem)]:hidden"
      background="/images/road.svg"
    >
    </section-layer>

    <section-container
      mobile-padding
      class="max-w-container lg:py-15 relative py-20 max-md:pt-[20rem] [@media(min-width:84.375rem)]:h-[138rem]"
    >
      <h2
        class="text-primary left-[33rem] top-[11rem] mb-5 text-[1.875rem] font-bold [@media(min-width:84.375rem)]:absolute"
      >
        Découverte de la plateforme
      </h2>

      <div
        class="left-[10rem] top-[25rem] mb-5 [@media(min-width:84.375rem)]:absolute"
      >
        <h3 class="text-primary font-[1.125rem] font-bold">
          Se rendre sur la plateforme
        </h3>
        <p class="font-[1.125rem] font-bold">
          pour avoir toutes les informations<br />
          de fonctionnement
        </p>
      </div>

      <div
        class="left-[42rem] top-[42rem] mb-5 [@media(min-width:84.375rem)]:absolute"
      >
        <h3 class="text-primary font-[1.125rem] font-bold">
          Création d’un compte sur la plateforme
        </h3>
        <ul class="font-[1.125rem] font-bold">
          <li>• Remplissez les champs d’informations générales</li>
          <li>• Fournissez votre habilitation et votre Kbis</li>
          <li>• Attendez la validation de votre compte</li>
        </ul>
      </div>

      <div class="grid-cols-2 md:grid">
        <div>
          <div
            class="left-[7rem] top-[56rem] mb-5 [@media(min-width:84.375rem)]:absolute"
          >
            <h3 class="text-secondary text-[1.875rem] font-semibold">
              Publier un trajet
            </h3>
          </div>

          <div
            class="left-[10rem] top-[83rem] mb-5 [@media(min-width:84.375rem)]:absolute"
          >
            <h3 class="text-secondary text-[1.375rem] font-bold">
              Vous souhaitez<br />
              optimiser votre transport ?
            </h3>
            <p class="text-[1.375rem] font-bold">
              Publiez votre trajet<br />
              effectué à vide
            </p>
          </div>

          <div
            class="left-[10rem] top-[96rem] mb-5 [@media(min-width:84.375rem)]:absolute"
          >
            <h3 class="text-secondary text-[1.375rem] font-bold">
              Remplissez les champs<br />
              selon vos besoins
            </h3>
            <p class="text-[1.375rem] font-bold">
              Disponibilités et possibilités
            </p>
          </div>

          <div
            class="left-[10rem] top-[108rem] mb-5 [@media(min-width:84.375rem)]:absolute"
          >
            <h3 class="text-secondary text-[1.375rem] font-bold">
              Attendez<br />
              qu’un opérateur réserve
            </h3>
            <p class="text-[1.375rem] font-bold">le trajet que vous proposez</p>
          </div>

          <div
            class="left-[10rem] top-[122rem] mb-5 [@media(min-width:84.375rem)]:absolute"
          >
            <h3 class="text-secondary text-[1.375rem] font-bold">
              Entre en contact<br />
              avec votre confrère
            </h3>
            <p class="text-[1.375rem] font-bold">
              pour une nouvelle collaboration
            </p>
          </div>
        </div>
        <div>
          <div
            class="right-[7rem] top-[56rem] mb-5 [@media(min-width:84.375rem)]:absolute"
          >
            <h3 class="text-ternary text-[1.875rem] font-semibold">
              Rechercher un trajet
            </h3>
          </div>

          <div
            class="right-[10rem] top-[83rem] mb-5 [@media(min-width:84.375rem)]:absolute [@media(min-width:84.375rem)]:text-right"
          >
            <h3 class="text-ternary text-[1.375rem] font-bold">
              Vous avez un défunt<br />
              à faire transporter ?
            </h3>
            <p class="text-[1.375rem] font-bold">
              Recherchez un trajet disponible !
            </p>
          </div>

          <div
            class="right-[10rem] top-[94rem] mb-5 [@media(min-width:84.375rem)]:absolute [@media(min-width:84.375rem)]:text-right"
          >
            <h3 class="text-ternary text-[1.375rem] font-bold">
              Saisissez vos critères<br />
              selon votre organisation
            </h3>
            <p class="text-[1.375rem] font-bold">
              et découvrez la liste<br />
              des opérateurs disponibles<br />
              pour prendre en charge<br />
              votre défunt
            </p>
          </div>

          <div
            class="right-[10rem] top-[112rem] mb-5 [@media(min-width:84.375rem)]:absolute [@media(min-width:84.375rem)]:text-right"
          >
            <h3 class="text-ternary text-[1.375rem] font-bold">
              Choisissez le trajet<br />
              qui correspond le mieux<br />
              à votre demande,
            </h3>
            <p class="text-[1.375rem] font-bold">
              réservez et payez-le<br />
              directement sur la plateforme
            </p>
          </div>
        </div>
      </div>
    </section-container>
  </section-wrapper>

  <section-wrapper class="bg-primary">
    <section-layer
      class="border-red absolute top-[50%] border-t-2 border-dashed"
    >
    </section-layer>

    <section-container
      mobile-padding
      class="max-w-container lg:py-15 bg-primary relative py-[7rem] text-center"
    >
      <div class="text-[1.25rem] font-bold text-white">
        Tous les paiements sont bloqués sur la plateforme jusqu’à la réalisation
        des transports
      </div>
      <div class="text-secondary text-[1.25rem] font-bold">
        et la somme est ensuite reversée à chaque opérateur une fois le travail
        effectué
      </div>
    </section-container>
  </section-wrapper>
</template>
<script setup></script>
